/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import {
	Component,
	Input,
	AfterViewInit,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	ViewChild,
	ElementRef,
	Renderer2,
} from '@angular/core';
import { S_IFIFO } from 'constants';

//TODO
// describe design
// setup autoclose thing, maybe make a global "something happened observable" that things can subscribe to when they're interested in users interacting with something else
//  maybe don't bother with one and just tie it to error-pin destruction (probably better)
// make all styling better
// set up rxjs extension for converting a form control into the input values the error-pin needs
//  should also handle non "us" errors (angular, create some generic text to use for them)
//  and should handle multiple errors, maybe just cascade them in whatever order they show up in? Could also include a weighting system in the data, that seems heavy though
// consider renaming and repurposing this component into not just being error related
// decide if we actually want the global error positioning thing, or just always derive the position based on the position of the error icon in whatever container that happens to be in
//  overflow: visible

@Component({
	selector: 'error-pin',
	templateUrl: './error-pin.component.html',
	styleUrls: ['./error-pin.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorPinComponent {
	@Input() public messageHeader = '';
	@Input() public message = '';
	@Input() public overlapInput = false;

	@ViewChild('messageRef', { read: ElementRef }) public messageRef: ElementRef;

	public showMessage = false;

	constructor(private cd: ChangeDetectorRef, private renderer: Renderer2) {}

	public toggleMessage() {
		this.showMessage = !this.showMessage;

		this.cd.detectChanges();

		if (this.showMessage) {
			this.detectTooLow();
		}
		if (this.overlapInput) {
			this.renderer.addClass(this.messageRef.nativeElement, 'error-message-menu-left-override');
		}
	}

	//special check for "doesn't fit on screen"
	public detectTooLow() {
		const rect = this.messageRef.nativeElement.getBoundingClientRect();
		if (rect.top + rect.height > window.innerHeight) {
			this.renderer.addClass(this.messageRef.nativeElement, 'error-message-menu-bottom-override');
		}
	}
}
